module.exports = __webpack_public_path__ + "img/Entertainment-low.c9733e6f.jpg";